module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-07-62abf7144a7f4a2e1da0d5bab3fb8098.png";